import React from 'react';

function Solution() {
  const productName = "PolitePay"; // Updated to actual name

  return (
    <section className="py-16 md:py-20 lg:py-28 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl mb-4 md:mb-6 font-bold text-primary">Introducing {productName}: Your Friendly Payment Reminder Bot</h2>
        <p className="max-w-3xl mx-auto mb-8 md:mb-10 text-primary-light">{productName} is laser-focused on one thing: sending polite, professional payment reminders automatically. No complex accounting software, no steep learning curve. Just simple, set-and-forget reminders so you can focus on your actual work.</p>
        <blockquote className="relative max-w-2xl mx-auto">
          <p className="text-lg sm:text-xl md:text-2xl font-medium text-accent italic leading-relaxed">"Focus on your work. We'll chase the payments."</p>
          {/* Optional: Add quote marks or styling */}
        </blockquote>
      </div>
    </section>
  );
}

export default Solution; 